import { render, staticRenderFns } from "./ProjectDetailModal.vue?vue&type=template&id=62001c22&scoped=true"
import script from "./ProjectDetailModal.vue?vue&type=script&lang=js"
export * from "./ProjectDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailModal.vue?vue&type=style&index=0&id=62001c22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62001c22",
  null
  
)

export default component.exports